import React from 'react';
import styled from 'styled-components';
import { useLanguage, LANGUAGES } from '../../contexts/LanguageContext';

const ToggleContainer = styled.div`
  display: inline-flex;
  background: #f0f0f0;
  border-radius: 16px;
  padding: 3px;
  gap: 0;
`;

const ToggleButton = styled.button`
  padding: 6px 12px;
  border: none;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 70px;
  
  ${props => props.$active ? `
    background: #262626;
    color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  ` : `
    background: transparent;
    color: #666;
    
    &:hover {
      color: #333;
      background: rgba(0, 0, 0, 0.05);
    }
  `}
  
  &:focus {
    outline: none;
  }
  
  &:focus-visible {
    outline: 2px solid #4A90E2;
    outline-offset: 2px;
  }
  
  @media (max-width: 480px) {
    padding: 5px 10px;
    font-size: 12px;
    min-width: 60px;
  }
`;

/**
 * LanguageToggle - A pill-style toggle for switching between English and Spanish
 */
const LanguageToggle = ({ style = {} }) => {
  const { language, setLanguage } = useLanguage();
  
  return (
    <ToggleContainer style={style}>
      <ToggleButton
        $active={language === LANGUAGES.EN}
        onClick={() => setLanguage(LANGUAGES.EN)}
        aria-label="Switch to English"
        type="button"
      >
        English
      </ToggleButton>
      <ToggleButton
        $active={language === LANGUAGES.ES}
        onClick={() => setLanguage(LANGUAGES.ES)}
        aria-label="Cambiar a Español"
        type="button"
      >
        Español
      </ToggleButton>
    </ToggleContainer>
  );
};

export default LanguageToggle;
